import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Register ({ setToken }) {
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone_number, setPhoneNumber] = useState("");
    const [password, setPassword ] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    async function handleRegister(e) {
        e.preventDefault();
        setError("");

        const response = await fetch("http://localhost:4000/api/users/register", {
            method: "POST",
            headers: {"Content-type": "application/json"},
            body: JSON.stringify({
                first_name,
                last_name,
                phone_number,
                email, 
                password
            }),
        });
        // let result = await response.json();
        navigate("/login", {replace: true});
        // const response = await fetch("http://localhost:4000/api/users/login", {
        //     method: "POST",
        //     headers: {"Content-type": "application/json"},
        //     body: JSON.stringify({
        //         email,
        //         password,
        //     }),
        // });
    };
    return (
        <div className="register">
            <form onSubmit={handleRegister}>
                <h1>Register</h1>
                <label htmlFor="email">First Name: </label>
                <input
                required
                placeholder="Pen"
                value={first_name}
                type="text"
                onChange={(e) => setFirstName(e.target.value)}
                />
                <label htmlFor="email">Last Name: </label>
                <input
                required
                placeholder="Fifteen"
                value={last_name}
                type="text"
                onChange={(e) => setLastName(e.target.value)}
                />
                <label htmlFor="email">Email: </label>
                <input
                required
                placeholder="example@penXV.com"
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)} 
                />
                <label htmlFor="email">Phone Number: </label>
                <input
                required
                placeholder="123-456-7890"
                value={phone_number}
                type="text"
                onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <label htmlFor="password">Password: </label>
                <input 
                required
                placeholder="Ex@mpl3Pa$$w0rd"
                type="password"
                value={password}
                onChange={(e) => setPassword (e.target.value)} 
                />
                <button> Register Here </button>
                <div className="signup-message">
                Already have an account? <Link to="/Login">Login</Link>
                </div>
                <p>{error}</p>
            </form>
        </div>
    );
};